"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
const multilingual_type_helper_1 = require("../../shared/multilingual-type-helper");
/**
 * Created by aghavni.grigoryan on 9/13/2017.
 */
class ListExportSettings {
    constructor() {
        this.headerFontStyle = null;
        this.footerFontStyle = null;
        this.exportHeader = new idm_crosscutting_concepts_frontend_1.MultilingualStringBuilder().build();
        this.exportFooter = new idm_crosscutting_concepts_frontend_1.MultilingualStringBuilder().build();
        this._isHeaderIncluded = false;
        this._isFooterIncluded = false;
        this._isPageNumberIncluded = false;
    }
    get exportHeader() {
        return this._exportHeader;
    }
    set exportHeader(exportHeader) {
        this._exportHeader = exportHeader;
    }
    get exportFooter() {
        return this._exportFooter;
    }
    set exportFooter(exportFooter) {
        this._exportFooter = exportFooter;
    }
    get isHeaderIncluded() {
        return this._isHeaderIncluded;
    }
    set isHeaderIncluded(isHeaderInclude) {
        this._isHeaderIncluded = isHeaderInclude;
    }
    get isFooterIncluded() {
        return this._isFooterIncluded;
    }
    set isFooterIncluded(isFootericlude) {
        this._isFooterIncluded = isFootericlude;
    }
    get isPageNumberIncluded() {
        return this._isPageNumberIncluded;
    }
    set isPageNumberIncluded(isPageNumberIncluded) {
        this._isPageNumberIncluded = isPageNumberIncluded;
    }
    toJsonString() {
        let toJsonData = "";
        toJsonData += "{";
        toJsonData += "\"listHeader\":";
        toJsonData += JSON.stringify(multilingual_type_helper_1.MultilingualTypeHelper.serializeMultilingualString(this.exportHeader));
        toJsonData += ",";
        toJsonData += "\"listFooter\":";
        toJsonData += JSON.stringify(multilingual_type_helper_1.MultilingualTypeHelper.serializeMultilingualString(this.exportFooter));
        toJsonData += ",";
        toJsonData += "\"isHeaderInclude\":";
        toJsonData += this.isHeaderIncluded;
        toJsonData += ",";
        toJsonData += "\"isFooterInclude\":";
        toJsonData += this.isFooterIncluded;
        toJsonData += ",";
        toJsonData += "\"headerFontStyle\":";
        toJsonData += JSON.stringify(this.headerFontStyle);
        toJsonData += ",";
        toJsonData += "\"footerFontStyle\":";
        toJsonData += JSON.stringify(this.footerFontStyle);
        toJsonData += ",";
        toJsonData += "\"isPageNumberIncluded\":";
        toJsonData += this.isPageNumberIncluded;
        toJsonData += "}";
        return toJsonData;
    }
    fromJson(exportSettingObject) {
        this.isHeaderIncluded = exportSettingObject.isHeaderInclude;
        this.isFooterIncluded = exportSettingObject.isFooterInclude;
        this.isPageNumberIncluded = exportSettingObject.isPageNumberIncluded;
        this.headerFontStyle = exportSettingObject.headerFontStyle;
        this.footerFontStyle = exportSettingObject.footerFontStyle;
        this.exportHeader = multilingual_type_helper_1.MultilingualTypeHelper.deserializeMultilingualString(exportSettingObject.listHeader);
        this.exportFooter = multilingual_type_helper_1.MultilingualTypeHelper.deserializeMultilingualString(exportSettingObject.listFooter);
    }
}
exports.ListExportSettings = ListExportSettings;
//# sourceMappingURL=list-export-settings.model.js.map